import { Tooltip } from '@mantine/core'
import type { TRole } from 'App/Map/Admin/utils/useAdminEntites'
import { Checkbox } from 'components/Checkbox/Checkbox'
import { IconInfoLight } from 'components/icons/IconInfoLight'
import React from 'react'
import { colors } from 'settings/colors'

const rowWrapperStyle = {
  'alignItems': 'center',
  'border': `1px solid ${colors.grey200}`,
  'display': 'flex',
  'padding': '4px 10px',
  'transition': '0.15s ease all',
  '&:hover': {
    background: colors.subtleBackground,
  },
}

export const RoleRow = ({
  role,
  selected,
  setSelected,
  hasEditPermission,
  style,
}: {
  role: TRole
  selected: boolean
  setSelected: (selected: boolean, roleId: TRole['id']) => void
  hasEditPermission: boolean
  style?: React.CSSProperties
}) => {
  return (
    <div
      css={{
        ...rowWrapperStyle,
        cursor: 'pointer',
        borderTop: undefined,
        ...style,
      }}
      onClick={() => {
        setSelected(!selected, role.id)
      }}
    >
      <>
        <Checkbox defaultChecked={selected} disabled={!hasEditPermission} css={{ marginRight: 12 }} />
        <div css={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <Tooltip label={role.description} withArrow position={'right'}>
            <span css={{ cursor: 'help', paddingRight: '5px' }}>
              <IconInfoLight />
            </span>
          </Tooltip>
          {role.name}
        </div>
      </>
    </div>
  )
}
